module.exports = __webpack_public_path__ + "img/37.c8e3ed19.png";